var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAR0lEQVR42mMY5oAx+NwZECZbM4PFBDAGscnTrJkPwnBDyNGMYQhZmjENodyANJoagA8TNoAARhiAB6QRxpS7gIFiF1AtvwAAEDeP+f+Cwd0AAAAASUVORK5CYII=";
  export default img;